<template>
  <dx-tree-view
      id="sideMenu"
      ref="treeViewRef"
      :items="items"
      key-expr="path"
      parent-id-expr="upMenuId"
      selection-mode="single"
      :focus-state-enabled="false"
      expand-event="click"
      @item-click="handleItemClick"
      @item-expanded="onItemExpanded"
      width="100%"
      no-data-text=""
  />
</template>

<script>
import router from '@/router'
import AppConfig from '@/config'
import {
	DxDataGrid,
	DxColumn,
	DxEditing,
	DxScrolling,
	DxSummary,
	DxLookup,
	DxPager,
	DxPaging,
	DxTotalItem
} from 'devextreme-vue/data-grid';
import DxTreeView from "devextreme-vue/ui/tree-view";
  import { locale, loadMessages, formatMessage } from 'devextreme/localization';

export default {
    name: 'sideMenu',
    components: { 
        DxTreeView,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxScrolling,
        DxSummary,
        DxLookup,
        DxPager,
        DxPaging,
        DxTotalItem
    },
  data () {
    return {
      menuList: null,
      items:[{}],
      nodeE: []
    }
  },  
  mounted: function () {

  },
  computed: {

  },
  methods : {
    handleItemClick(e) {
      //$("#sideMenu [aria-level='1']").removeClass('dx-treeview-node-is-leaf');
      if(e.node.itemData.menuUrlAddr!=null && e.node.itemData.menuUrlAddr!=undefined && e.node.itemData.menuUrlAddr!=""){
        this.$emit('select-low-menu', e.node.itemData.menuNm);
        this.$router.push({path: e.node.itemData.menuUrlAddr})
      }else{
        if(e.node.parent == null){
          this.nodeE.forEach(i => {
            this.$refs['treeViewRef'].instance.collapseItem(i)
          })
          this.nodeE = []
        }
//        this.$refs['treeViewRef'].instance.expandItem(e.itemElement)
      }
    },
    onItemExpanded(e){
      this.nodeE.push(e.itemElement)
    },
    open(val) { // init
      this.items = val;
      this.$nextTick(function () {
      })
    },
    goMenu (menuId) {
      var curName = this.$router.history.current.name;
      var curPath = this.$router.history.current.path;

      if (curName != menuId) {
        window.$store.dispatch('LatestMenu/deleteLatestMenu', {name: menuId}).then(response => {
          this.$router.push({name: menuId, params: {refresh : true }});
        });
      } else {
        this.$router.push(curPath + '?' + this.pageIndex++)
      }

    }
  }    
}
</script>



// WEBPACK FOOTER //
// src/components/SideMenu.vue